import cookie from 'react-cookie';
import moment from 'moment';
import { SOURCECLEAR_COMPONENTS } from '~/constants/ModelConstants';
import config from '~/config';

const oneHourInMins = 60;
const oneDayInMins = oneHourInMins * 24;

const CookieService = function() {
  // Default expiry in 1 day
  const setCookie = (key, val, expiresIn = oneDayInMins) => {
    const isSecure = !!config.BEARER_DOMAINS.find(domain =>
      window.location.hostname.endsWith(domain)
    );
    config.BEARER_DOMAINS.forEach(domain => {
      cookie.save(key, val, {
        expires: moment()
          .add(expiresIn, 'minute')
          .toDate(),
        domain: domain,
        secure: isSecure,
        path: '/' + SOURCECLEAR_COMPONENTS.VULNERABILITY_DATABASE.slug,
      });
    });
  };

  const setCookieNoExpiry = (key, val) => {
    // Expire in 10 years, as good as no expiry
    setCookie(key, val, 60 * 24 * 365 * 10);
  };

  const getCookie = key => {
    return cookie.load(key);
  };

  const removeCookie = key => {
    config.BEARER_DOMAINS.forEach(domain => {
      cookie.remove(key, {
        domain: domain,
        path: '/' + SOURCECLEAR_COMPONENTS.VULNERABILITY_DATABASE.slug,
      });
    });
  };

  return {
    setCookie,
    setCookieNoExpiry,
    getCookie,
    removeCookie,
  };
};

export default new CookieService();
